import { MapLayerGroupControl } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerGroupControl';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { update as updateMapLayerConfig } from '@/features/mapLayerSlice';
import { LayerType } from '@/views/map/layers/types';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { WildfireLegend } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerOption/WildfireLegend';
import TagManager from 'react-gtm-module';
import { GoogleEvents } from '@/features/googleEvents';

export const WildfireRiskControl = () => {
  const dispatch = useAppDispatch();
  const layerConfig = useAppSelector((s) => s.mapLayer);

  const isActive = layerConfig[LayerType.wildfire_risk].visible;

  const toggleWildfireLayer = (v: boolean) => {
    TagManager.dataLayer({
      dataLayer: {
        event: v ? GoogleEvents.wildfireLayerOn : GoogleEvents.wildfireLayerOff,
      },
    });
    return dispatch(
      updateMapLayerConfig({
        [LayerType.wildfire_risk]: { visible: v },
      })
    );
  };

  const isSmallScreen = useSmallScreen();

  return (
    <>
      <MapLayerGroupControl
        title="Wildfire risk zones"
        onVisibilityChange={toggleWildfireLayer}
        isGroupVisible={isActive}
        data-testid="wildfire-risk-control"
      />
      {isSmallScreen && <WildfireLegend />}
    </>
  );
};
